/*
 * � 2020 Microsoft. All rights reserved.
 */

define('audiosprites',['text!audiosprites.json'], function(as) {

    return JSON.parse(as);

});

